import { getApiUrl } from '../../../config/api';
import { post } from '../../../utils/request-manager';

export default class EditMotivoRechazoViewController {
  constructor() {
    this.motivoRechazo = {
      IdMotivoRechazo: 0,
      Descripcion: ''
    };
    this.loading = false;
    this.saving = false;
    this.error = null;
    this.motivoRechazoId = null;
  }

  // Inicialización del controlador
  initialize(motivoRechazoId) {
    this.motivoRechazoId = motivoRechazoId;
    this.loadMotivoRechazo();
  }

  // Cargar motivo de rechazo
  async loadMotivoRechazo() {
    if (!this.motivoRechazoId) {
      this.error = 'ID de motivo de rechazo no válido.';
      return;
    }

    this.loading = true;
    this.error = null;

    try {
      const response = await post(getApiUrl('/api/MotivoRechazo/lectura'), {
        IdMotivoRechazo: Number(this.motivoRechazoId)
      });
      
      if (response.data.Data && response.data.Data.length > 0) {
        this.motivoRechazo = response.data.Data[0];
      } else {
        this.error = 'Motivo de rechazo no encontrado.';
      }
    } catch (error) {
      console.error('Error al cargar motivo de rechazo:', error);
      this.error = 'No se pudo cargar el motivo de rechazo. Por favor, intente nuevamente.';
    } finally {
      this.loading = false;
    }
  }

  // Actualizar campo
  updateField(field, value) {
    this.motivoRechazo[field] = value;
  }

  // Validar formulario
  validateForm() {
    const errors = [];

    if (!this.motivoRechazo.Descripcion || this.motivoRechazo.Descripcion.trim() === '') {
      errors.push('La descripción es requerida.');
    }

    if (this.motivoRechazo.Descripcion && this.motivoRechazo.Descripcion.length > 500) {
      errors.push('La descripción no puede exceder 500 caracteres.');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  }

  // Guardar cambios del motivo de rechazo
  async saveMotivoRechazo() {
    // Validar formulario
    const validation = this.validateForm();
    if (!validation.isValid) {
      return {
        success: false,
        message: validation.errors.join(' ')
      };
    }

    this.saving = true;
    this.error = null;

    try {
      const formData = {
        MotivoRechazo: this.motivoRechazo
      };

      const response = await post(getApiUrl('/api/MotivoRechazo/guardar'), formData, {}, false);
      
      if (response.data.Number > 0) {
        return {
          success: true,
          message: 'Motivo de rechazo actualizado correctamente.',
          response
        };
      } else {
        return {
          success: false,
          message: 'No se pudo actualizar el motivo de rechazo.',
          response
        };
      }
    } catch (error) {
      console.error('Error al actualizar motivo de rechazo:', error);
      return {
        success: false,
        message: 'No se pudo actualizar el motivo de rechazo. Por favor, verifique los datos e intente nuevamente.',
        error
      };
    } finally {
      this.saving = false;
    }
  }
}